import moment from 'moment';

import Base from './Base';

export default class ShipmentManifest extends Base {
    constructor(props) {
        super();

        this.import(props);
    }

    import(props) {
        if (typeof props === 'number') {
            props = { id: props };
        }
        if (!props) {
            props = {}
        }

        this.id = this.assign('id', props);
        this.date = props.date || this.date || '';
        this.status = this.assign('status', props);
        this.itemCount = this.assign('itemCount', props);
        this.items = props.items || this.items || [];
        this.createdAt = props.createdAt ? moment(props.createdAt) : this.createdAt;
        this.updatedAt = props.updatedAt ? moment(props.updatedAt) : this.updatedAt;
    }

    export() {
        return {
            date: this.date
        }
    }
}
